import { render, staticRenderFns } from "./ShowVersion.vue?vue&type=template&id=3f531bd4&scoped=true&"
import script from "./ShowVersion.vue?vue&type=script&lang=js&"
export * from "./ShowVersion.vue?vue&type=script&lang=js&"
import style0 from "./ShowVersion.vue?vue&type=style&index=0&id=3f531bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f531bd4",
  null
  
)

export default component.exports